"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonNotes_de_de = void 0;
function commonNotes_de_de() {
    return {
        "notes.privatehint": "Private Notiz",
        "notes.private": "Privat"
    };
}
exports.commonNotes_de_de = commonNotes_de_de;
